import React from 'react';
import ReactDOM from "react-dom";
import TimeLine from './TimeLine';
import Map from './Map';
import Graph from './Graph';

const DATA = [{"year":1922,"viviendas":  false,"fecha":"10 de noviembre de 1922","magnitud":8.5,"muertos":1500,"poblacion":3720235,"moneda":"CLP","danos":30,"geo":{"lat":-28.500,"lon":-70.000}} ,{"year":1939,"viviendas":  845,"fecha":"24 de enero de 1939","magnitud":8.3,"muertos":5648,"poblacion":4287445,"danos":3000,"moneda":"CLP","geo":{"lat":-36.200,"lon":-72.200}},{"year":1960,"viviendas":  false,"fecha":"22 de mayo de 1960","magnitud":9.5,"muertos":2000,"poblacion":5932995,"danos":700,"moneda":"USD","geo":{"lat":-39.500,"lon":-74.500}},{"year":1985,"viviendas":  85358,"fecha":"3 de marzo de 1985","magnitud":8,"muertos":178,"poblacion":11329736,"danos":1046,"moneda":"USD","geo":{"lat":-33.240,"lon":-71.850}},{"year":2010,"viviendas":  500000,"fecha":"27 de febrero de 2010","magnitud":8.8,"muertos":525,"poblacion":15116435,"danos":29662,"moneda":"USD","geo":{"lat":-36.290,"lon":-73.239}},{"year":2014, "viviendas": 1389,"fecha":"1 de abril de 2014","magnitud":8.2,"muertos":7,"poblacion":16634603,"danos":700,"moneda":"USD","geo":{"lat":-19.572,"lon":-70.908}},{"year":2015, "viviendas": 2442,"fecha":"16 de septiembre de 2015","magnitud":8.4,"muertos":15,"poblacion":16634603,"danos": false,"moneda":"USD","geo":{"lat":-31.535,"lon":-71.919}}];
const first = DATA[0];
export default  class App extends React.Component {
  constructor(props) {
    super(props);
    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
    this.state = {
      map: null,
      //active: 'all'
      active: first.year,
      activeItem: first,
      vibration: (navigator.vibrate)
    };
  }
  handleClick(item) {
    console.log("click")
    console.log(item.year);
    if(this.state.vibration){
      navigator.vibrate(800);
    }
    this.setState({
      active: item.year,
      activeItem: item
    });

  }
  render() {

    return (
      <section className="infografia-terremoto columns">
        <div className="columns small-12">
          <div className="logo columns small-12 medium-8 small-centered"></div>
        </div>
        <Map items={DATA} onClick={this.handleClick} active={this.state.active} />
        <div className="columns small-12 medium-7">
          <TimeLine items={DATA} onClick={this.handleClick} main={this} active={this.state.active} />
          <Graph items={DATA} active={this.state.active} item={this.state.activeItem} />
        </div>
      </section>
    );
  }
}

ReactDOM.render(
  <App />,
  document.getElementById('container-infografia-terremoto')
)



/** WEBPACK FOOTER **
 ** ./client/main.js
 **/